import { useState, useEffect } from 'react';
import { anotherInstance } from './hookConnect';

const ButtonClickTable = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [refreshKey, setRefreshKey] = useState(0);
    const [isDataFullyLoaded, setIsDataFullyLoaded] = useState(false);

    const reloadData = () => {
        setRefreshKey(prevKey => prevKey + 1);
    };

    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();

        const fetchButtonClickList = async () => {
            try {
                setLoading(true);
                setError(null);
                setIsDataFullyLoaded(false);
                
                const response = await anotherInstance.get(`analyst/button/get`, {
                    signal: controller.signal,
                    timeout: 30000 // 30 секунд таймаут
                });
                
                if (!isMounted) return;
                
                if (response.data && Array.isArray(response.data.data)) {
                    setData(response.data.data);
                    setIsDataFullyLoaded(true);
                } else {
                    setData([]);
                    setError('Неверный формат данных');
                }
            } catch (error) {
                if (!isMounted) return;
                setError(`Ошибка загрузки: ${error.message}`);
                setData([]);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        fetchButtonClickList();

        return () => {
            isMounted = false;
            controller.abort();
        };
    }, [refreshKey]);

    return { data, loading, error, reloadData, isDataFullyLoaded };
};

export default ButtonClickTable;